import { Form, Mentions, Select } from 'antd'
import { useCallback, useMemo, useState } from 'react'

const numFormFields = 4

export default function Schedule({ parameters, fieldName }) {
  const [selectedValue, setSelectedValue] = useState([])
  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .map(({ name }) => name)
      .filter((item) => !selectedValue.includes(item))
      .map((item) => ({ label: item, value: item }))
  }, [parameters, selectedValue])

  const availableArrayInteger = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type, items }) => type === 'array' && items?.type === 'string')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters, selectedValue])

  const handleValueChange = useCallback(
    (value) =>
      setSelectedValue((old) =>
        old?.length < numFormFields ? [...old, value] : old
      ),
    []
  )

  return (
    <>
      <Form.Item
        label={'Horário de início'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'start']}
      >
        <Select
          placeholder={'Início'}
          options={available}
          onChange={handleValueChange}
        />
      </Form.Item>
      <Form.Item
        label={'Horário de encerramento'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'end']}
      >
        <Select
          placeholder={'Fim'}
          options={available}
          onChange={handleValueChange}
        />
      </Form.Item>
      <Form.Item label={'ID da agenda'}
                 help={"Esse id é retornado nas outras rotas, de check e list."}
                 name={[fieldName, 'action', 'data', 'calendarID']}>
          <Select placeholder={'ID da agenda'}
                  options={available}
                  onChange={handleValueChange}/>
      </Form.Item>
      <Form.Item
        label={'Convidados'}
        help={'Você deve ter criado um parametro lista de inteiros no gatilho'}
        name={[fieldName, 'action', 'data', 'invites']}
      >
        <Select
          placeholder={'Seleciona a variável de convidados'}
          options={availableArrayInteger}
          onChange={handleValueChange}
        />
      </Form.Item>
      <Form.Item
        label={'Assunto da reunião'}
        name={[fieldName, 'action', 'data', 'summary']}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item
        label={'Descrição'}
        name={[fieldName, 'action', 'data', 'description']}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item label={'Local'} name={[fieldName, 'action', 'data', 'local']}>
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
    </>
  )
}
